import "./ProfileNotificationSettingsEdit.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ProfileNotificationSettingsEditComponentController from "./ProfileNotificationSettingsEditComponentController";

export default class ProfileNotificationSettingsEditComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = ProfileNotificationSettingsEditComponentController;
        this.templateUrl =
            "/App/Modules/Auth/Components/Profile/NotificationSettings/EditForm/ProfileNotificationSettingsEdit.html";
    }
}

module("mmAuth").component("mmProfileNotificationSettingsEdit", new ProfileNotificationSettingsEditComponent());
